import {
  createAsyncThunk,
  AnyAction,
  PayloadAction,
  createSlice,
} from "@reduxjs/toolkit";
import { setToastNotification } from "../../../../components/ToastNotification/service/toastNotificationSlice";
import { LeadAutomationInitialStateDTO } from "./types";
import {
  GetLeadAutomation,
  ChangeLeadAutomationStatus,
  SaveLeadAutomationConfig,
  UpdateLeadAutomationConfig,
  DeleteLeadAutomationConfig,
} from "./settings.request";

export const initialState: LeadAutomationInitialStateDTO = {
  getSavedLeadAutomationLoading: false,
  getSavedLeadAutomationSuccess: false,
  getSavedLeadAutomationError: false,
  getSavedLeadAutomationData: null,
  changeLeadAutomationStatusLoading: false,
  changeLeadAutomationStatusSuccess: false,
  changeLeadAutomationStatusError: false,
  saveLeadAutomationConfigLoading: false,
  saveLeadAutomationConfigSuccess: false,
  saveLeadAutomationConfigError: false,
  editLeadAutomationConfigLoading: false,
  editLeadAutomationConfigSuccess: false,
  editLeadAutomationConfigError: false,
  deleteLeadAutomationConfigLoading: false,
  deleteLeadAutomationConfigSuccess: false,
  deleteLeadAutomationConfigError: false,
};

export const getLeadAutomation = createAsyncThunk(
  "automation/getLeadAutomation",
  async (id: string, thunkAPI: any) => {
    return GetLeadAutomation(id)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const changeLeadAutomationStatus = createAsyncThunk(
  "automation/changeLeadAutomationStatus",
  async (data: any, thunkAPI: any) => {
    return ChangeLeadAutomationStatus(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const saveLeadAutomationConfig = createAsyncThunk(
  "automation/saveLeadAutomationConfig",
  async (data: any, thunkAPI: any) => {
    return SaveLeadAutomationConfig(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const editLeadAutomationConfig = createAsyncThunk(
  "automation/editLeadAutomationConfig",
  async (data: any, thunkAPI: any) => {
    return UpdateLeadAutomationConfig(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const deleteLeadAutomationConfig = createAsyncThunk(
  "automation/deleteLeadAutomationConfig",
  async (data: any, thunkAPI: any) => {
    return DeleteLeadAutomationConfig(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);
export const leadAutomationSlice = createSlice({
  name: "leadAutomationSlice",
  initialState,
  reducers: {
    reset: () => initialState,
    resetStatusUpdateSuccess: (state) => {
      state.changeLeadAutomationStatusSuccess = false;
    },
    resetSaveUpdateSuccess: (state) => {
      state.saveLeadAutomationConfigSuccess = false;
      state.editLeadAutomationConfigSuccess = false;
    },
    resetDeleteSuccess: (state) => {
      state.deleteLeadAutomationConfigSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getLeadAutomation.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.getSavedLeadAutomationLoading = false;
        state.getSavedLeadAutomationSuccess = true;
        state.getSavedLeadAutomationError = false;
        state.getSavedLeadAutomationData = action?.payload;
      }
    );
    builder.addCase(getLeadAutomation.rejected, (state, action: AnyAction) => {
      state.getSavedLeadAutomationLoading = false;
      state.getSavedLeadAutomationSuccess = false;
      state.getSavedLeadAutomationError =
        action?.error?.message || "Something went wrong";
    });
    builder.addCase(getLeadAutomation.pending, (state) => {
      state.getSavedLeadAutomationLoading = true;
      state.getSavedLeadAutomationSuccess = false;
      state.getSavedLeadAutomationError = false;
    });

    builder.addCase(
      changeLeadAutomationStatus.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.changeLeadAutomationStatusLoading = false;
        state.changeLeadAutomationStatusSuccess = true;
        state.changeLeadAutomationStatusError = false;
      }
    );
    builder.addCase(
      changeLeadAutomationStatus.rejected,
      (state, action: AnyAction) => {
        state.changeLeadAutomationStatusLoading = false;
        state.changeLeadAutomationStatusSuccess = false;
        state.changeLeadAutomationStatusError =
          action?.error?.message || "Something went wrong";
      }
    );
    builder.addCase(changeLeadAutomationStatus.pending, (state) => {
      state.changeLeadAutomationStatusLoading = true;
      state.changeLeadAutomationStatusSuccess = false;
      state.changeLeadAutomationStatusError = false;
    });
    builder.addCase(
      saveLeadAutomationConfig.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.saveLeadAutomationConfigLoading = false;
        state.saveLeadAutomationConfigSuccess = true;
        state.saveLeadAutomationConfigError = false;
      }
    );
    builder.addCase(
      saveLeadAutomationConfig.rejected,
      (state, action: AnyAction) => {
        state.saveLeadAutomationConfigLoading = false;
        state.saveLeadAutomationConfigSuccess = false;
        state.saveLeadAutomationConfigError =
          action?.error?.message || "Something went wrong";
      }
    );
    builder.addCase(saveLeadAutomationConfig.pending, (state) => {
      state.saveLeadAutomationConfigLoading = true;
      state.saveLeadAutomationConfigSuccess = false;
      state.saveLeadAutomationConfigError = false;
    });
    builder.addCase(
      editLeadAutomationConfig.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.editLeadAutomationConfigLoading = false;
        state.editLeadAutomationConfigSuccess = true;
        state.editLeadAutomationConfigError = false;
      }
    );
    builder.addCase(
      editLeadAutomationConfig.rejected,
      (state, action: AnyAction) => {
        state.editLeadAutomationConfigLoading = false;
        state.editLeadAutomationConfigSuccess = false;
        state.editLeadAutomationConfigError =
          action?.error?.message || "Something went wrong";
      }
    );
    builder.addCase(editLeadAutomationConfig.pending, (state) => {
      state.editLeadAutomationConfigLoading = true;
      state.editLeadAutomationConfigSuccess = false;
      state.editLeadAutomationConfigError = false;
    });

    builder.addCase(
      deleteLeadAutomationConfig.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.deleteLeadAutomationConfigLoading = false;
        state.deleteLeadAutomationConfigSuccess = true;
        state.deleteLeadAutomationConfigError = false;
      }
    );
    builder.addCase(
      deleteLeadAutomationConfig.rejected,
      (state, action: AnyAction) => {
        state.deleteLeadAutomationConfigLoading = false;
        state.deleteLeadAutomationConfigSuccess = false;
        state.deleteLeadAutomationConfigError =
          action?.error?.message || "Something went wrong";
      }
    );
    builder.addCase(deleteLeadAutomationConfig.pending, (state) => {
      state.deleteLeadAutomationConfigLoading = true;
      state.deleteLeadAutomationConfigSuccess = false;
      state.deleteLeadAutomationConfigError = false;
    });
  },
});

export default leadAutomationSlice.reducer;
export const {
  reset,
  resetStatusUpdateSuccess,
  resetSaveUpdateSuccess,
  resetDeleteSuccess,
} = leadAutomationSlice.actions;
